export { default as Badge, badgeType } from './badge';
export { badgeStandard } from './__fixtures__/badge';
